import { Block } from '../../types';

export function isBlockUploading(block: Block): boolean {
  const { type } = block.content;
  if (type === 'text' || type === 'mutual-action-plan') {
    return false;
  } else if (type === 'image') {
    return (
      block.content.fileStatus === 'in-progress' ||
      block.content.dalleStatus === 'uploading' ||
      block.content.dalleStatus === 'dalle-generating'
    );
  } else if (type === 'video' || type === 'pdf' || type === 'attachment' || type === 'ms-office') {
    return block.content.fileUploadStatus === 'in-progress';
  } else if (type === 'placeholder') {
    return false;
  } else if (type === 'link') {
    return false;
  } else if (type === 'logo' || type === 'talk-to-journey') {
    return false;
  } else if (type === 'contents-list') {
    return false;
  } else if (type === 'signup') {
    return false;
  } else if (type === 'native-e-signature') {
    return false;
  } else if (type === 'table') {
    return false;
  } else if (type === 'cta-button') {
    return false;
  } else if (type === 'native-form') {
    return false;
  }
  const _exhaustiveCheck: never = type;
  throw new Error(`Unexpected block type: ${_exhaustiveCheck}`);
}
